import { apiClient } from '../_helpers';
const apiPath = 'userFavorites/';
export const favoriteService = {
    get,
    add,
    remove
};
async function get(params) {
    try {
        const response = await apiClient(`${apiPath}?userId=${params.userId}&recipeId=${params.recipeId}`)
            .get();
        return response.data;
    } catch (error) {
        return error;
    }
}
async function add(params) {
    try {
        const response = await apiClient(apiPath)
            .post('', `${JSON.stringify(params)}`);
        return response.data;
    } catch (error) {
        return error;
    }
}
async function remove(params) {
    try {
        const response = await apiClient(apiPath)
            .delete(params);
        return response.data;
    } catch (error) {
        return error;
    }
}